module.exports = __webpack_public_path__ + "static/media/kids.3ed6ff24.png";